/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

/**
 * @file retail-selector.js
 * @description Redux selectors for accessing retail state data
 */

import { createSelector } from "@reduxjs/toolkit";

/**
 * @function getRetailSelectedPlayerAccountId
 * @description Selector that returns the retail selected player account id data from state
 * @param {Object} state - Redux state
 * @returns {*} Selected state data
 */
export const getRetailSelectedPlayerAccountId = (state) => state.retailAccount?.selectedPlayerAccountId;

/**
 * @function getRetailSelectedPlayerAccountData
 * @description Selector that returns the retail selected player account data data from state
 * @param {Object} state - Redux state
 * @returns {*} Selected state data
 */
export const getRetailSelectedPlayerAccountData = createSelector(
  (state) => state.retailAccount?.selectedPlayerAccountData,
  (selectedPlayerAccountData) => selectedPlayerAccountData,
);

/**
 * @function getRetailTillDetails
 * @description Selector that returns the retail till details data from state
 * @param {Object} state - Redux state
 * @returns {*} Selected state data
 */
export const getRetailTillDetails = createSelector(
  (state) => state.retailTill?.tillDetails,
  (tillDetails) => tillDetails,
);

/**
 * @function getRetailPlayerAccountBalance
 * @description Selector that returns the retail player account balance data from state
 * @param {Object} state - Redux state
 * @returns {*} Selected state data
 */
export const getRetailPlayerAccountBalance = createSelector(
  (state) => state.retailAccount?.playerAccountBalance,
  (playerAccountBalance) => playerAccountBalance,
);
